import { ExamplePlayfulInputPhone, ExamplePlayfulInputPhoneMedium, ExamplePlayfulInputPhoneMediumInvalid, ExamplePlayfulInputPhoneDisabled, ExamplePlayfulInputPhoneInvalid } from "../../../../../../packages/design-system/src/PlayfulInputPhone/readme-helpers";
import * as React from 'react';
export default {
  ExamplePlayfulInputPhone,
  ExamplePlayfulInputPhoneMedium,
  ExamplePlayfulInputPhoneMediumInvalid,
  ExamplePlayfulInputPhoneDisabled,
  ExamplePlayfulInputPhoneInvalid,
  React
};